<script setup lang="ts">
const router = useRouter()
</script>

<template>
  <div class="claim-search-layout">
    <AppToolbar class="sticky top-0">
      <div class="flex h-full items-center">
        <div class="h1 flex items-center space-x-2 pr-4">
          <UiFindClaimIcon class="h-10 w-11" />
          <span>Claim Search</span>
        </div>
      </div>
      <template #user-menu>
        <UiBtnClose @click="router.push('/dashboard')" />
      </template>
    </AppToolbar>

    <slot />
  </div>
</template>

<style scoped>
.claim-search-layout {
  @apply grid h-dvh;
  grid-template-rows: 64px auto;
}
</style>
